
import React from 'react';
import { Form, Col} from 'react-bootstrap';
import { getIn } from 'formik';
import NumberFormat from '../../NumberFormat';
import Age from '../Age';

export default class Pension extends React.Component {

     render(){
        return(
                <Form.Row>
                    <Age form={this.props.form} type={this.props.type} />
                     <Form.Group as={Col} md="4" controlId="validationFormikage">
                        <Form.Label>Start Age</Form.Label>
                        <NumberFormat
                            value={getIn(this.props.values, `${this.props.type}.age`)} 
                            onValueChange={e => { 
                                this.props.setFieldValue( `${this.props.type}.age`, e.floatValue);
                                this.props.setFieldTouched( `${this.props.type}.age`,true);  }}
                            error={getIn(this.props.errors, `${this.props.type}.age`) }
                            format={'##'}
                            />
                    </Form.Group>
                    <Form.Group as={Col} md="4" controlId="validationFormikamount">
                        <Form.Label><strong>Monthly</strong> Amount</Form.Label>
                        <NumberFormat
                            value={getIn(this.props.values, `${this.props.type}.amount`)}  
                            thousandSeparator={true} 
                            prefix={'$'} 
                            onValueChange={e => { 
                                this.props.setFieldValue( `${this.props.type}.amount`, e.floatValue);
                                this.props.setFieldTouched( `${this.props.type}.amount`,true);  }}
                            error={getIn(this.props.errors, `${this.props.type}.amount`) }
                            />
                    </Form.Group>
                    {/* <Form.Group as={Col} md="3" controlId="validationFormikCOLA">
                        <Form.Label>Projected COLA (%)</Form.Label>
                        <NumberFormat
                            value={getIn(this.props.values, `${this.props}.cola`)} 
                            onValueChange={e => { 

                                this.props.setFieldValue( `${this.props.type}.cola`, parseFloat(e.formattedValue) );
                                this.props.setFieldTouched( `${this.props.type}.cola`,true);  }}
                            error={getIn(this.props.errors, `${this.props.type}.cola`) }
                            format={decimalFormat.bind(this)}
                            />
                    </Form.Group> */}
                </Form.Row>
        );
    }
}